import { connect } from "react-redux";

import { FetchOptions } from "./fetch-options";

function fetchOptionFactory(fetchAction, unloadAction) {
  function mapDispatchToProps(dispatch) {
    return {
      fetch: () => {
        return new Promise((resolve, reject) => {
          dispatch(
            fetchAction({
              resolve,
              reject,
            }),
          );
        });
      },
      unload: () => {
        dispatch(unloadAction);
      },
    };
  }

  return connect(null, mapDispatchToProps)(FetchOptions);
}

export { fetchOptionFactory };
